import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

@Index('_tag_unique', ['tag'], { unique: true })
@Entity('_tag')
export class TagEntity extends BaseEntity {
	@Column('varchar', { name: '_tag', nullable: true, unique: true, length: 50 })
	public tag!: string | null;
}
